import { getVorlageActualRegion, getVorlageDisplayName } from "./vorlagenHelpers";

const MRT_VARIANTS = ["MRT 1,5", "MRT 3"];

const EMPTY_BEFUNDBEISPIELE = {};

export const createEmptyBefundbeispiele = () => ({});

export const createEmptyProtokolle = () => ({});

export const getModTargets = (mod) => (mod === "MRT" ? MRT_VARIANTS : [mod]);

export const isMrtVariant = (mod) => MRT_VARIANTS.includes(mod);

const normalizePromptName = (value) => String(value || "").trim();

const matchesPromptName = (prompt, name) => {
  const normalizedName = String(name || "").trim();
  if (!normalizedName) return false;

  return [
    prompt?.name,
    getVorlageDisplayName(prompt),
    getVorlageActualRegion(prompt),
  ].some((candidate) => String(candidate || "").trim() === normalizedName);
};

const findPromptByName = (vorlagen, name, mod) => {
  const promptList = Array.isArray(vorlagen) ? vorlagen : [];
  const normalizedName = normalizePromptName(name);
  if (!normalizedName) return null;

  const inMod = promptList.filter((prompt) => prompt?.mod === mod);
  const exactRawMatch = inMod.find((prompt) => normalizePromptName(prompt?.name) === normalizedName);
  if (exactRawMatch) return exactRawMatch;

  return inMod.find((prompt) => matchesPromptName(prompt, normalizedName)) || null;
};

export const findCustomPrompt = (vorlagen, name, mod) => {
  if (!name) return null;

  if (!mod) {
    const promptList = Array.isArray(vorlagen) ? vorlagen : [];
    const normalizedName = normalizePromptName(name);
    const nonSpecial = promptList.filter(
      (prompt) => prompt?.mod !== "Volumetrie" && prompt?.mod !== "Modalitäten"
    );

    const exactRawMatch = nonSpecial.find((prompt) => normalizePromptName(prompt?.name) === normalizedName);
    if (exactRawMatch) return exactRawMatch;

    return (
      nonSpecial.find((prompt) => matchesPromptName(prompt, normalizedName)) || null
    );
  }

  const exact = findPromptByName(vorlagen, name, mod);
  if (exact) return exact;

  if (MRT_VARIANTS.includes(mod)) {
    return findPromptByName(vorlagen, name, "MRT");
  }

  return null;
};

export const mapBefundbeispieleRows = (rows, createEmptyState = createEmptyBefundbeispiele) => {
  const grouped = createEmptyState();

  for (const row of rows || []) {
    const modGroup = row?.mod_group || "Sonstiges";
    const section = row?.data?.section;
    if (!section) continue;

    if (!grouped[modGroup]) grouped[modGroup] = {};
    if (!grouped[modGroup][section]) grouped[modGroup][section] = [];

    grouped[modGroup][section].push({
      ...(row?.data || {}),
      id: row?.id,
      createdAt: row?.created_at,
    });
  }

  for (const modGroup of Object.keys(grouped)) {
    for (const section of Object.keys(grouped[modGroup])) {
      grouped[modGroup][section].sort((left, right) => {
        const leftHasOrder = left.order_index != null;
        const rightHasOrder = right.order_index != null;

        if (leftHasOrder && rightHasOrder) return left.order_index - right.order_index;
        if (leftHasOrder) return -1;
        if (rightHasOrder) return 1;

        return Number(right.createdAt || 0) - Number(left.createdAt || 0);
      });
    }

    const orderedSections = Object.entries(grouped[modGroup])
      .map(([section, list], index) => {
        const explicitOrder = (list || [])
          .map((entry) => entry?.section_order_index)
          .filter((value) => value != null)
          .map(Number)
          .filter(Number.isFinite);

        return {
          section,
          list,
          index,
          order: explicitOrder.length ? Math.min(...explicitOrder) : null,
        };
      })
      .sort((left, right) => {
        const leftHasOrder = left.order != null;
        const rightHasOrder = right.order != null;

        if (leftHasOrder && rightHasOrder) return left.order - right.order;
        if (leftHasOrder) return -1;
        if (rightHasOrder) return 1;

        return left.index - right.index;
      });

    grouped[modGroup] = orderedSections.reduce((acc, entry) => {
      acc[entry.section] = entry.list;
      return acc;
    }, {});
  }

  return grouped;
};

export { EMPTY_BEFUNDBEISPIELE };
